export const promoteSpeaker = (
  order: string[],
  visibleCount: number,
  speaking: string[],
  lastSpokeAt: ReadonlyMap<string, number>
): string[] => {
  if (visibleCount <= 0 || visibleCount >= order.length) {
    return order
  }

  const hidden = order.slice(visibleCount)
  const promoted = speaking.find((identity) => hidden.includes(identity))

  if (!promoted) {
    return order
  }

  const quietest = order
    .slice(0, visibleCount)
    .reduce((quiet, identity) =>
      (lastSpokeAt.get(identity) ?? 0) < (lastSpokeAt.get(quiet) ?? 0) ? identity : quiet
    )

  return order.map((identity) => {
    if (identity === promoted) {
      return quietest
    }

    return identity === quietest ? promoted : identity
  })
}
